import { render, staticRenderFns } from "./ProjectTags.vue?vue&type=template&id=1e40d589&scoped=true&"
import script from "./ProjectTags.vue?vue&type=script&lang=ts&"
export * from "./ProjectTags.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTags.vue?vue&type=style&index=0&id=1e40d589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e40d589",
  null
  
)

export default component.exports